export class HidePageButton {
    private _currentContext: JQuery = null;
    private _url: string = null;

    private bindEvents(): void {
        this._currentContext.on("click", () => window.location.replace(this._url));
    }

    public init(context: JQuery, url: string): void {
        this._currentContext = context || this._currentContext;
        this._url = url || this._url;

        this.bindEvents();
    }

    public static init(context: JQuery, url: string): HidePageButton {
        const component = new HidePageButton();
        component.init(context, url);
        return component;
    }
}
